import PrimaryCell from "../../../../../ui/Table/Cells/PrimaryCell";
import LinkCell from "./LinkCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "number",
    cellRender: PrimaryCell,
    width: 75
  },
  {
    dataField: "assign",
    caption: "Назначение",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "name",
    caption: "Название",
    dataType: "string",
    cellRender: LinkCell
  },
  {
    dataField: "siteAccessName",
    caption: "Условия доступа",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "orgName",
    caption: "Организация",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "depName",
    caption: "Подразделение",
    dataType: "string",
    cellRender: PrimaryCell
  }
];
